import classNames from 'classnames';
import NetworkIcon from '@/shared/icons/flip-ui-kit/large/Network';

export const OperatorLogo = ({
  size,
  idSs58: _idSs58, // TODO(delegation): add other operator logos
}: {
  size: 'small' | 'large';
  idSs58: string;
}) => (
  <div
    className={classNames(
      'rounded-full border border-cf-white/10',
      size === 'small' ? 'h-4 w-4' : 'h-8 w-8',
    )}
  >
    <div
      className="flex h-full w-full items-center justify-center rounded-full"
      style={{
        background:
          'radial-gradient(63.94% 63.94% at 50% 0%, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.00) 100%), #2C2D2C',
        boxShadow: '2.844px 2.844px 18.487px 0 rgba(0, 0, 0, 0.25) inset',
      }}
    >
      <NetworkIcon secondaryColor="white" className="text-cf-light-2" />
    </div>
  </div>
);
